module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "",
      "type": "inverse",
      "variant": "success",
      "sticky": true
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "#"
    }
  }, [_c('span', [_vm._v("Vue BS Drawer Example")])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item', [_vm._v("Support")]), _vm._v(" "), _c('b-nav-item', [_vm._v("Docs")]), _vm._v(" "), _c('b-nav-item', [_vm._v("Contact Us")])], 1), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "text": "Lang",
      "right": ""
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("EN")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("ES")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("RU")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("FA")])], 1), _vm._v(" "), _c('b-nav-item-dropdown', {
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("User")])]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("Profile")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("Signout")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('bs-drawer', {
    ref: "leftDrawer",
    staticClass: "col-10 col-sm-3 col-md-3 col-lg-2 bs-drawer__animate",
    attrs: {
      "side": "left",
      "showDrawer": false,
      "showToggleBtn": true,
      "btnTop": "195px",
      "bg": "transparent",
      "sidebar": "md"
    },
    on: {
      "bs-drawer-opened": _vm.closeRight
    }
  }, [_c('b-card', {
    staticClass: "ml-3 my-3",
    attrs: {
      "header": "Sidebar Nav"
    }
  }, [_c('b-nav', {
    attrs: {
      "vertical": ""
    }
  }, [_c('b-nav-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('b-nav-item', [_vm._v("Link")]), _vm._v(" "), _c('b-nav-item', [_vm._v("Another Link")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Disabled")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "px-4 col-12 col-md-9 col-lg-10 offset-md-3 offset-lg-2"
  }, [_c('router-view')], 1), _vm._v(" "), _c('bs-drawer', {
    ref: "rightDrawer",
    staticClass: "col-9 col-sm-8 col-md-4 col-lg-4 col-xl-2 bs-drawer__animate",
    attrs: {
      "side": "right",
      "showDrawer": false,
      "btnStyle": _vm.rightBtnStyles[_vm.styleIndex],
      "btnTop": 0
    },
    on: {
      "bs-drawer-opened": _vm.closeLeft
    }
  }, [_c('b-nav', {
    attrs: {
      "vertical": ""
    }
  }, [_c('b-nav-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('b-nav-item', [_vm._v("Link")]), _vm._v(" "), _c('b-nav-item', [_vm._v("Another Link")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Disabled")])], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.toggleStyle
    }
  }, [_vm._v("Button styles")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a38cd28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/App.vue
// module id = 846
// module chunks = 1